<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Horaire d'ouverture</h1>
                    <p>Gestion des heures d'ouverture</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.scopeopeninghour.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un horaire</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :menus="menus" :active-query="false" :active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>
                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.agenda.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                              <figure>
                                <icon name="calendar"/>
                              </figure>
                            </div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="name"><strong class="highlight">{{ item.name }}</strong></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.agenda.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.agenda.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>

    import {constants} from '../../../const.js'
    import Agenda from './AgendaService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                dataSelectedFilter: null,
                days_week: constants.days_week,
                menus: [
                    {
                        slug: 'calendar',
                        name: 'Slots'
                    },
                    {
                        slug: 'opening-hours',
                        name: 'Horaire ouverture'
                    },
                    {
                        slug: 'closure',
                        name: 'Vacances / Fermeture'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return Agenda;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/agenda/Index.vue